
import styled from '@emotion/styled';


const Title = styled.p`
	font-size: 1.5rem;
	text-align: center;
	margin: 1rem;
`;

const Div = styled.div`
	margin-bottom: 2rem;
	display: block;
	text-align: center;
`;


const Click = styled.p`
	display: flex;
	justify-content: center;
	text-align: center;
	padding: 1rem;
`;

const Span = styled.span`
	font-size: 1rem;
`;


const Img = styled.img`
	@media (min-width: 768px) {
		width: 500px;
		height: 500px;
		display: block;
		margin-left: auto;
		margin-right: auto;
		:hover {
			transform: scale(1.05);
		}
	}
`;

export {Title, Div, Click, Span, Img};